import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import JobCard from '../components/JobCard';
import { API_URL, formatDate, getStatusBadgeClass, licenseOptions } from '../lib/utils';
import { toast } from 'sonner';
import {
  Briefcase,
  Bookmark,
  FileText,
  User,
  Settings,
  Loader2,
  Upload,
  MapPin,
  Phone,
  Calendar,
  Building2,
  ExternalLink,
  Award,
  GraduationCap,
  Trash2,
  FileCheck,
  Archive,
  MessageSquare,
  Sparkles,
  CheckCircle2,
  AlertCircle,
} from 'lucide-react';
import MessagesPanel from '../components/MessagesPanel';
import { useJobSeekerCtx } from './JobSeekerContext';


const JobSeekerTabSaved = () => {
  const { handleUnsaveJob, savedJobs } = useJobSeekerCtx();
  return (
    <>
            {savedJobs.length > 0 ? (
              <div className="space-y-4">
                {savedJobs.map((job) => (
                  <JobCard
                    key={job.job_id}
                    job={job}
                    isSaved={true}
                    onUnsave={handleUnsaveJob}
                  />
                ))}
              </div>
            ) : (
              <div className="bg-white rounded-xl border border-gray-100 text-center py-12">
                <Bookmark className="w-12 h-12 text-gray-300 mx-auto mb-4" />
                <h3 className="font-medium text-gray-900 mb-2">No saved jobs</h3>
                <p className="text-gray-500 mb-4">Save jobs you're interested in to apply later.</p>
                <Link to="/jobs">
                  <Button className="bg-primary hover:bg-primary-hover text-white">
                    Browse All Jobs
                  </Button>
                </Link>
              </div>
            )}
    </>
  );
};

export default JobSeekerTabSaved;
